module.exports = __webpack_public_path__ + "static/RMPUA-cbb8a715fa5d037c049c8dd94948fd67.ttf";